export const MAX_FORECAST_NAME_LENGTH = 100;
export const MAX_FORECASTS = 5;

// Forecast Type Wizard Tracking types
export const TRACK_NAME_FORECAST_TYPE = 'name-forecast-type';
export const TRACK_SELECT_DATE_TYPE = 'select-date-type';
export const TRACK_SELECT_AMOUNT_TYPE = 'select-amount-type';
export const TRACK_CREATE_FORECAST_TYPE = 'create-forecast-type';
export const TRACK_CREATE_FORECAST_WIZARD_STEP_1 = 'create-forecast-wizard-step-1';
export const TRACK_CLOSE_WIZARD_AND_SKIP_GOAL_CREATION = 'close-wizard-and-skip-goal-creation';
export const TRACK_CLOSE_WIZARD_AND_CREATE_GOAL = 'close-wizard-and-create-goal';
export const TRACK_CANCEL_WIZARD = 'cancel-create-forecast-type-wizard';
export const TRACK_COMPLETE_WIZARD = 'complete-create-forecast-type-wizard';

// Edit Default Columns Modal Tracking
export const TRACK_OPEN_EDIT_COLUMNS_MODAL_IN_WIZARD = 'open-edit-default-columns-modal';
export const TRACK_SAVE_COLUMNS_FROM_WIZARD = 'track-save-default-columns';
export const OVERWRITE_USER_DEFINED_COLUMNS = 'overwrite-user-defined-columns';
export const MAINTAIN_USER_DEFINED_COLUMNS = 'maintain-user-defined-columns';
export const CLOSE_OVERRIDE_MODAL_WITHOUT_SAVE = 'close-override-modal-without-save';
export const ANNUAL_RECURRING_REVENUE = 'hs_arr';
export const MONTHLY_RECURRING_REVENUE = 'hs_mrr';
export const RECURRING_REVENUE_AMOUNT_PROPERTIES = [ANNUAL_RECURRING_REVENUE, MONTHLY_RECURRING_REVENUE];